<template>
  <div
    class="OrderSelection"
    v-if="doingActionVerb && doingActionOrders.length > 0"
  >
    <div class="OrderSelection__text">
      <span class="OrderSelection__loading"
        >{{ doingActionVerb }} {{ doingActionOrders.length }} order<span
          v-show="doingActionOrders.length > 1"
          >s</span
        >
        with <strong>{{ qty(doingActionOrders) }}</strong></span
      >
    </div>
  </div>
  <div class="OrderSelection OrderSelectionError" v-else-if="error">
    <div class="OrderSelection__text">
      <div><strong>Error: </strong>{{ error }}</div>
    </div>
    <div class="OrderSelectionError__button">
      <btn @click="closeError">try again</btn>
    </div>
  </div>
  <div class="OrderSelection" v-else-if="value.length && value.length > 0">
    <div class="OrderSelection__text">
      Do what with <strong>{{ value.length }}</strong> order<span
        v-show="value.length > 1"
        >s</span
      >
      (<strong>{{ qty(value) }}</strong
      >)?
      <slot :doAction="doAction"></slot>
      <btn @click="$emit('input', [])">Cancel</btn>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      error: null,
      doingActionVerb: null,
      doingActionOrders: [],
    };
  },
  watch: {
    value(value) {
      if (this.error && value.length > 0) {
        this.closeError();
      }
    },
  },
  methods: {
    // Here's why this function has to exist

    // Actions passed into this component are async functions with one or more GraphQL mutations.
    // When a GraphQL mutation return with new order data, Apollo updates it's cache with the new order data
    // and when Apollo updates it's cache, components that are reliant on the order data re-render

    // One such component is the OrderTable component.
    // The OrderTable component renders the vue2-datatable-component,
    // and when order data is passed to vue2-datatable-component it changes the selection to an empty array

    // Since this component relies on selection's length to display,
    // it would disappear if our action had more than one GraphQL mutation

    // So, to get around this, we can keep a local cache of the orders outside of the vue data flow until the action is done
    async doAction(verb, action) {
      if (this.doingAction) {
        return;
      }

      this.doingActionVerb = verb;
      this.doingActionOrders = this.value.slice();
      try {
        await action(this.doingActionOrders);
        this.$emit('input', []); // reset order selection
      } catch (e) {
        console.error(e);
        this.error = e.message;
      }

      this.doingActionVerb = null;
      this.doingActionOrders = [];
    },
    qty(orders) {
      const cases = orders.reduce((sum, order) => sum + order.cases, 0);
      const bottles = orders.reduce((sum, order) => sum + order.bottles, 0);

      let qty = '';
      if (cases > 0) {
        qty += cases + 'c';
      }
      if (cases > 0 && bottles > 0) {
        qty += ' ';
      }
      if (bottles > 0) {
        qty += bottles + 'bt';
      }
      return qty;
    },

    closeError() {
      this.error = null;
    },
  },
};
</script>

<style>
.OrderSelection {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #428bca;
  color: white;
  font-size: 16px;
  padding: 5px;

  display: flex;
  align-items: center;
}
.OrderSelectionError {
  background-color: red;
}
.OrderSelection__text {
  margin: 0 auto;
}
.OrderSelection__loading:after {
  content: ' .';
  animation: dots 1s steps(5, end) infinite;
}

@keyframes dots {
  0%,
  20% {
    color: rgba(0, 0, 0, 0);
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  40% {
    color: white;
    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  60% {
    text-shadow: 0.25em 0 0 white, 0.5em 0 0 rgba(0, 0, 0, 0);
  }
  80%,
  100% {
    text-shadow: 0.25em 0 0 white, 0.5em 0 0 white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OrderSelection.vue